import Header from './components/Header';
import HeroSection from './components/HeroSection';
import SectionCards from './components/SectionCards';
import SectionUpdates from './components/SectionUpdates';
import SectionCarousel from './components/SectionCarousel';
import SectionRanking from './components/SectionRanking';
import SectionFaq from './components/SectionFaq';
import SectionFeatures from './components/SectionFeatures';
import SectionComments from './components/SectionComments';
import SectionAbout from './components/SectionAbout';
import SectionApp from './components/SectionApp';
import SectionMedia from './components/SectionMedia';
import SectionTopics from './components/SectionTopics';
import SectionContact from './components/SectionContact';
import SectionIndex from './components/SectionIndex';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <SectionCards />
        <SectionUpdates />
        <SectionCarousel />
        <SectionRanking />
        <SectionFaq />
        <SectionFeatures />
        <SectionComments />
        <SectionAbout />
        <SectionApp />
        <SectionMedia />
        <SectionTopics />
        <SectionContact />
        <SectionIndex />
      </main>
      <Footer />
    </>
  );
}